import React, {useState, useEffect} from 'react';

function Edit(props) {

    const {history} = props
    const userId = props.match.params.id

    const [user, setUser] = useState({
        id: userId,
        username: "",
        email: "",
    })

    useEffect(() => {

        //ajax
        setTimeout(() => {

            setUser({
                id: userId,
                username: "jack",
                email: "jack@qq.com",
            })

        }, 1000)

    }, [])


    useEffect(() => {

        let time = setInterval(() => {
            console.log("12345")
        }, 1000)

        return () => {
            clearInterval(time)
        }
    })


    function handleClick() {
        console.log(user)

        history.push("/member")
    }


    return (
        <div>
            <h2>Edit</h2>
            <div>name:
                <input type="text"
                       value={user.username}
                       onChange={e => {
                           setUser({username: e.target.value.trim()})
                       }}
                />
            </div>

            <div>email:
                <input type="text"
                       value={user.email}
                       onChange={e => {
                           setUser({email: e.target.value.trim()})
                       }}
                />
            </div>
            <div>
                <button onClick={handleClick}>提交</button>
            </div>
        </div>
    )
}

export default Edit